// src/api/appConfigs/endpoints.ts
export const APP_CONFIGS_ENDPOINTS = {
  TILMID_PLUS: "/v1/app-configs/tilmid-plus",
  /** Fournisseurs et modèles déclarés, chaque modèle avec son tarif en vigueur. */
  LLM_CATALOG: "/v1/llm-settings/catalog",
  /** Ajouter ou modifier un fournisseur (jamais sa clé). */
  LLM_PROVIDER: (id: string) => `/v1/llm-settings/providers/${encodeURIComponent(id)}`,
  /** Déclarer un modèle : capacités et tarif (inséré dans ai_model_price). */
  LLM_MODELS: "/v1/llm-settings/models",
  /** Prompts de base de l'extraction et de la relecture des faits, avec leur version. */
  FACT_PROMPTS: "/v1/llm-settings/prompts",
  /** Coût d'un objectif extrait ou d'une quête servie, par rôle et par modèle tarifé (14 jours). */
  COST_ESTIMATES: "/v1/llm-settings/cost-estimates",
  /** Jetons d'accès personnels de l'atelier tc_docsourcing (liste, création pour soi). */
  ACCESS_TOKENS: "/v1/access-tokens",
  /** Révoquer un jeton : effet immédiat. */
  ACCESS_TOKEN: (id: string) => `/v1/access-tokens/${encodeURIComponent(id)}`,
  /** tc_learn (par le broker) : prompts de la génération et de la relecture des quêtes. */
  QUEST_PROMPTS: "/admin/prompts",
} as const;
